import { Question } from "interfaces/question";
export const interviewPabllo: Question[] = [
  {
    id: 1,
    title: "Qual é o seu maior hit de chuveiro?",
    answer:
      "Ai, gente, me veio uma surra de música na cabeça! Mas acho que meu hit de chuveiro vai ter que ser “Alcohol-free”, do Twice.",
  },
  {
    id: 2,
    title: "Quem moldou a sua música, quem que você cresceu ouvindo?",
    answer:
      "Forró sem parar! Aviões do Forró, Solteirões do Forró, Forró do Muido, Taty Girl... Menina, tudo o que você imaginar de forró! Sei tudo: Lagosta Bronzeada, Tropicália. A lista é longa!",
  },
  {
    id: 3,
    title:
      "Se você pudesse fazer um feat. com qualquer artista do mundo, quem seria?",
    answer:
      "Beyoncé. Agora que já fiz com a Gaga, né? Já tenho o elo perfeito para fazer o “Telephone 2” acontecer.",
  },
  {
    id: 4,
    title:
      "Quais são os três melhores discos de música pop da história segundo Pabllo Vittar?",
    answer:
      "Fácil! The Fame (2008), da Gaga, a grande estreia, com certeza. Ah! O da Rihanna, o Anti (2016), que foi o último que ela lançou (aliás, gata, favor voltar com novidades!). E, por último, para fechar, o Born to die, da Lana del Rey. Podia ir para uma ilha deserta com esses três álbuns.",
  },
  {
    id: 5,
    title: "Três músicas de outros artistas para dar beijo na boca!",
    answer:
      "Vamos lá: “Kiss me more”, da Doja Cat, “Paris 1985”, de Lecomte de Brégot (essa eu já beijei de verdade ouvindo), e “Ultraviolence”, de Lana (bate palma) del (bate palma) Rey (bate palma)!",
  },
  {
    id: 6,
    title: "O que tocaria na sua estreia nas passarelas de Paris como modelo?",
    answer:
      "Ia tocar uma coisa assim bem tecnológica, bem hi-fi, bem summer, verão, mas com uma pegada tipo, com uma cuíca, sabe? Porque Brasil, something like that, né? Para poder desfilar e jogar o meu charme brasileiro. Então, é isso, uma coisa bem abstrata, bem tecnológica, nada de vocal, tá? Um techninho para elas.",
  },
  {
    id: 7,
    title:
      "Quais artistas que vieram antes de você foram fundamentais para o seu trabalho?",
    answer: "Verônica, a drag. Que deus a tenha.",
  },
];
